import { Injectable } from '@angular/core';
import { tooltipData } from './tpbTooltips';
import { of, firstValueFrom } from 'rxjs';

@Injectable()
export class TooltipService {
  private tooltips: any = {};

  load(): Promise<any> {
    const response = firstValueFrom(of(tooltipData))
      .then((data) => {
        for (const element in data) {
          this.tooltips[element] = data[element].value;
        }
      })
      .catch(function (ex) {
        console.error(ex);
      });

    return response;
  }

  getTooltip(name: string): string {
    return this.tooltips[name];
  }
}
